module.exports = __webpack_public_path__ + "img/xiaomi.538fa50a.png";